import React, { FC, useState } from 'react';

import { useI18n } from 'i18n';
import Toggle from 'core/react/general/form/Toggle';
import { getOwMap } from 'core/react/general/location/Map';

interface IMapRotationSwitchProps {
  mapName: string;
}

export const MapRotationSwitch: FC<IMapRotationSwitchProps> = ({ mapName }) => {
  const { f } = useI18n();

  const map = getOwMap(mapName);

  const [value, setValue] = useState(map?.isMapRotation());

  const onChange = () => {
    map.rotateMap(!value);
    setValue(map.isMapRotation());
  };

  return (
    map && (
      <div className="map-option display-marker-labels">
        <Toggle label={f('Rotate map')} value={value} onChange={onChange} />
      </div>
    )
  );
};
